export const presentationalwrapperConfig = {
    name: 'PresentationalWrapper',
    category: 'Zapier Utilities',
    canHaveChildren: true,
};
//# sourceMappingURL=config.js.map